import Button from "components/BaseWidgets/button";
import Divider from "components/BaseWidgets/divider";
import AlertNotification from "components/CustomWidgets/alertNotification";
import CopyInput from "components/CustomWidgets/referFriendModal/components/CopyInput";
import Footer from "components/CustomWidgets/referFriendModal/components/Footer";
import HeaderInfo from "components/CustomWidgets/referFriendModal/components/HeaderInfo";
import Working from "components/CustomWidgets/referFriendModal/components/Working";
import { retrieveToken } from "utils/storage";

function ReferAFriend() {
  const user = JSON.parse(retrieveToken("user"));
  const referCode = user?.refer_code;
  const ref_link = user?.refer_link;

  const handleSendInvites = async () => {
    try {
      await navigator.clipboard.writeText(`${ref_link}`);
      AlertNotification("success", "Site link copied!");
    } catch (error) {
      console.error("Clipboard API failed, using fallback", error);
      const textArea = document.createElement("textarea");
      textArea.value = `${ref_link}`;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
      AlertNotification("success", "Site link copied!");
    }
  };
  return (
    <>
      <div className="settings-card-layout">
        <div className="flex flex-col gap-6 items-center content">
          <HeaderInfo />
          <div className="flex flex-col gap-4 items-center">
            <CopyInput className="copy-input" value={referCode} />
            <Button
              variant="secondary"
              className="invite-btn"
              onClick={handleSendInvites}
            >
              Send Invites
            </Button>
          </div>
        </div>
        <Divider color="#672666" className="mt-6 mb-6" />
        <Working />
        <Footer />
      </div>
    </>
  );
}

export default ReferAFriend;
